import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csfirstpro(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript hello World Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript First Programming tutorial for beginners First Programming or hello World in Javascript Inside text editor when we create a Javascript project so after the name of file name use extension and .cs is the extensive use for Javascript" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript First Programming,javascript first program,head first javascript programming,Javascript exit for loop,First Programming in Javascript" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-first-program" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Basic program in Javascript</h1>
    <div className="first">
        <a href="/javascript-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 <h2 className="mt-4 mh2">Steps of hello World program in Javascript or First program in Javascript:</h2>
<p className="mt-4 para">
1, Firstly, use HTML code for creating js outside the structure<br/>
2, Use a script tag inside the head or a body<br/>
3, if you print anything so type <br/><br/>
<span className="bold">document.write("Hello World!");</span><br/><br/>
4, And after use close Script Tag
</p>



<h2 className="headings">Q-Write a Hello World program in Javascript Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}
            
      <span className="qwerty-10">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Hello World!"</span>
      <span className="qwerty-1">);</span>
      {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
            {"\n"}
     </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello World!</span>   
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write the Basic Example of Javascript Program?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}
          
  <span className="qwerty-10">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"sports</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"sports</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-10">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"1,football</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"2,badminton </span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-10">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"3,tennis</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"4,cricket</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-10">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"hello world program in Javascript"</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Hello World!"</span>
      <span className="qwerty-1">);</span>
      {"\n"}







<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;sports </span>          
          {"\n"}
          <span className="qwerty-5">&nbsp;1</span>   
          <span className="qwerty-3">,football </span>         
          {"\n"}
          <span className="qwerty-5">&nbsp;2</span>   
          <span className="qwerty-3">,badminton </span>         
          {"\n"}
          <span className="qwerty-5">&nbsp;3</span>   
          <span className="qwerty-3">,tennis </span>         
          {"\n"}
          <span className="qwerty-5">&nbsp;4</span>   
          <span className="qwerty-3">,cricket </span>         
          {"\n"}{"\n"}
          <span className="qwerty-3">&nbsp;Hello world program in Javascript </span> {"\n"}
          <span className="qwerty-3">&nbsp;Hello World!</span>   
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csfirstpro;